import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CookiebotUser } from '../models';
import { SessionService } from 'src/app/angular-services-v8/session.service';


@Injectable({
  providedIn: 'root'
})
export class CookiebotUserService {
  private apiEndpoint: string = (window as any).API_HOST || '';
  private apiKey: string = (window as any).CLIENT_ID || '';
  private appCode: string = (window as any).APP_CODE || '';

  constructor(private http: HttpClient, private sessionService: SessionService) { }

  public saveConsentLogger(body: CookiebotUser): Observable<any> {
    const uri = this.apiEndpoint + 'v5/secm/audit/log';
    const headers = { headers: this.getHeaders() };
    return this.http.post(uri, body, headers);
  }

  private getHeaders(): HttpHeaders {
    const { jwt, oauth2 } = this.sessionService.dataSession ?? {};
    return new HttpHeaders({
      authorization: `Bearer ${oauth2.access_token ?? ''}`,
      jwt: jwt ?? '',
      'app-code': this.appCode,
      'x-ibm-client-id': this.apiKey,
      'accept-language': 'en-US',
    });
  }

}
